import axios from "axios";
import "../../App.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getGlobalVar, setGlobalVar } from "../../config/Config";
import Header from "../../components/Header";
import { Space, Table, Button, DatePicker } from "antd";
import dayjs from "dayjs";
import { getOrderedProducts, getOrders } from "../../repository/ordersApi";

const { RangePicker } = DatePicker;

const SalesReport = ({ mode }) => {
  const auth = JSON.parse(localStorage.getItem("auth"));
  const org = auth?.org;

  const [globalVar, setValue] = useState(getGlobalVar());
  const [orders, setOrders] = useState([]);
  const [dateFilter, setDateFilter] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    fetchOrders();
  }, [mode]);

  const fetchOrders = async () => {
    try {
      const data = await (mode === "orders"
        ? getOrderedProducts()
        : getOrders());

      setOrders(data);
    } catch (err) {
      console.log(err);
    }
  };

  const handlePrint = () => {
    const filteredData = getFilteredData();
    const tableHTML = `
      <table border="1" style="border-collapse: collapse; width: 100%;">
        <thead>
          <tr>${columns.map((col) => `<th>${col.title}</th>`).join("")}</tr>
        </thead>
        <tbody>
          ${filteredData
            .map(
              (row) =>
                `<tr>${columns
                  .map((col) => {
                    let val = row[col.dataIndex];
                    if (col.dataIndex === "status")
                      val = val ? "Completed" : "Pending";
                    if (col.dataIndex === "customer" && !val) val = "—";
                    if (col.dataIndex === "payment" && val)
                      val = JSON.stringify(val);
                    return `<td>${val ?? ""}</td>`;
                  })
                  .join("")}</tr>`
            )
            .join("")}
        </tbody>
      </table>
    `;
    const newWindow = window.open("", "_blank");
    newWindow.document.write(
      `<html><head><title>Print</title></head><body>${tableHTML}</body></html>`
    );
    newWindow.document.close();
    newWindow.print();
  };

  const handleDownloadCSV = () => {
    const filteredData = getFilteredData();
    const header = columns.map((col) => col.title).join(",");
    const csvRows = filteredData.map((row) =>
      columns
        .map((col) => {
          let val = row[col.dataIndex];
          if (col.dataIndex === "status") val = val ? "Completed" : "Pending";
          if (col.dataIndex === "customer" && !val) val = "—";
          if (col.dataIndex === "payment" && val) val = JSON.stringify(val);
          return `"${val ?? ""}"`;
        })
        .join(",")
    );
    const csvContent = [header, ...csvRows].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "sales-report.csv";
    link.click();
  };

  const getFilteredData = () => {
    if (!dateFilter) return orders;
    const [start, end] = dateFilter;
    return orders.filter((order) => {
      const orderDate = dayjs(order.date);
      return (
        orderDate.isAfter(dayjs(start).subtract(1, "day")) &&
        orderDate.isBefore(dayjs(end).add(1, "day"))
      );
    });
  };

  const columns = [
    mode === "orders" ? { title: "ID", dataIndex: "id", key: "id" } : null,
    mode === "orders"
      ? {
          title: "Order Ref",
          dataIndex: "order_ref",
          key: "order_ref",
        }
      : null,
    mode === "orders"
      ? {
          title: "Product",
          dataIndex: ["product", "ProductName"],
          key: "product.ProductName",
        }
      : null,
    mode === "orders"
      ? {
          title: "Price",
          dataIndex: "price",
          key: "price",
        }
      : null,
    mode === "orders"
      ? {
          title: "QTY",
          dataIndex: "quantity",
          key: "quantity",
        }
      : null,
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date) => dayjs(date).format("YYYY-MM-DD"),
    },
    mode === "sales"
      ? { title: "Session", dataIndex: "session", key: "session" }
      : null,
    mode === "sales"
      ? {
          title: "Fiscal Position",
          dataIndex: "fiscal_position",
          key: "fiscal_position",
        }
      : null,
    mode === "sales"
      ? {
          title: "Status",
          dataIndex: "status",
          key: "status",
          render: (status) => (status ? "Completed" : "Pending"),
        }
      : null,
    mode === "sales" ? { title: "User", dataIndex: "User", key: "User" } : null,
    mode === "sales"
      ? {
          title: "Customer",
          dataIndex: "customer",
          key: "customer",
          render: (customer) => customer ?? "—",
        }
      : null,
    mode === "sales"
      ? {
          title: "Payment",
          dataIndex: "payment",
          key: "payment",
          render: (payment) => (payment ? JSON.stringify(payment) : "—"),
        }
      : [],
  ].filter(Boolean);

  return (
    <div className="d-flex" style={{ height: "100vh" }}>
      <Header />

      <div style={{ flex: "11 11 100%", padding: "20px", marginTop: "64px" }}>
        <div className="row">
          <div className="col-6">
            <h1 className="text-2xl font-bold">
              {mode === "orders" ? "Orders" : "Sales Report"}
            </h1>
          </div>
          <div className="col-6" />
        </div>

        <div className="row p-4">
          <div className="col-12 r-shadow pt-2">
            <Space style={{ marginBottom: 16 }}>
              <RangePicker onChange={(dates) => setDateFilter(dates)} />
              <Button type="primary" onClick={handlePrint}>
                Print
              </Button>
              <Button
                type="primary"
                style={{ backgroundColor: "green", borderColor: "green" }}
                onClick={handleDownloadCSV}
              >
                Download CSV
              </Button>
            </Space>
            <Table columns={columns} dataSource={getFilteredData()} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesReport;
